// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CartPageHeader-module-container-lOvIK{display:grid;grid-template-columns:1fr;padding-block:0 20px;padding-inline:20px 0;align-items:center}@media(min-width: 960px){.CartPageHeader-module-container-lOvIK{grid-template-columns:1fr auto}}.CartPageHeader-module-title-eDf5C{color:#373a36;font-size:32px;font-weight:var(--weight-light);letter-spacing:0;line-height:44px}.CartPageHeader-module-subtitle-xSVcJ{color:#666b69}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "CartPageHeader-module-container-lOvIK",
	"title": "CartPageHeader-module-title-eDf5C",
	"subtitle": "CartPageHeader-module-subtitle-xSVcJ"
};
export default ___CSS_LOADER_EXPORT___;
